import styled from 'styled-components';
import { token, spaceMixin } from '@zillow/constellation';
var StatusIcon = styled.span.withConfig({
  displayName: "StatusIcon",
  componentId: "sc-nth902-0"
})(["margin-right:", ";flex-shrink:0;font-size:10px;height:1em;width:1em;border-radius:", ";display:inline-block;background-color:", ";"], spaceMixin(1), token('radii.ellipse'), function (props) {
  switch (props.icon) {
    case 'zsg-icon-for-sale':
      return token('colors.forSale');

    case 'zsg-icon-for-rent':
      return token('colors.forRent');

    case 'zsg-icon-pre-market':
      return token('colors.comingSoon');

    case 'zsg-icon-recently-sold':
      return token('colors.recentlySold');

    case 'zsg-icon-off-market':
      return token('colors.offMarket');

    default:
      return token('colors.offMarket');
  }
});
export default StatusIcon;
//# sourceMappingURL=StatusIcon.js.map